export default function playAlertSound () {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext
    if (!AudioContext) {
      return
    }
    const audioContext = new AudioContext()
    const beepDuration = 0.2
    const beepGap = 0.15
    const playBeep = (startTime) => {
      const oscillator = audioContext.createOscillator()
      const gainNode = audioContext.createGain()
      oscillator.connect(gainNode)
      gainNode.connect(audioContext.destination)
      oscillator.type = 'sine'
      oscillator.frequency.value = 800
      gainNode.gain.setValueAtTime(0, startTime)
      gainNode.gain.linearRampToValueAtTime(1, startTime + 0.01)
      gainNode.gain.setValueAtTime(1, startTime + beepDuration - 0.02)
      gainNode.gain.linearRampToValueAtTime(0, startTime + beepDuration)
      oscillator.start(startTime)
      oscillator.stop(startTime + beepDuration)
    }
    const resumeAndPlay = () => {
      const now = audioContext.currentTime
      for (let i = 0; i < 2; i++) {
        playBeep(now + i * (beepDuration + beepGap))
      }
    }
    if (audioContext.state === 'suspended') {
      audioContext.resume().then(resumeAndPlay).catch(() => {})
    } else {
      resumeAndPlay()
    }
  } catch (e) {
    // Browser may block autoplay without prior user interaction
  }
}
